export default "__VITE_ASSET__df8f9399__"